export const emailReg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
export const numAndWordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/
export const numOrWordReg = /^[0-9a-zA-Z]*$/
export const rtmpReg = /^((rtmp|rtmps):\/\/).*$/
export const nicknameReg = /^[a-zA-Z]*$/
